import { useTranslation } from 'react-i18next';
import { AppleLoginButton } from 'react-social-login-buttons';
import { getAuthorisationURLWithQueryParamsAndSetState } from 'supertokens-auth-react/recipe/thirdparty';

import { isSuperTokensError } from 'src/Components/Auth/ThirdPartySignInHandler/ThirdPartySignInHandler.component';

import styles from './AppleSignInButton.module.scss';

const AppleSignInButton = ({ compact }: { compact: boolean }) => {
  const { t } = useTranslation();
  const handleAppleLoginClick = async () => {
    try {
      const authUrl = await getAuthorisationURLWithQueryParamsAndSetState({
        thirdPartyId: 'apple',
        frontendRedirectURI: `${import.meta.env.VITE_PUBLIC_URL}/auth/callback`,
        redirectURIOnProviderDashboard: `${import.meta.env.VITE_API_URL}/auth/callback/apple`,
      });

      window.location.assign(authUrl);
    } catch (err: unknown) {
      if (isSuperTokensError(err)) {
        window.alert(err.message);
      } else {
        window.alert('Oops! Something went wrong.');
      }
    }
  };

  return (
    <AppleLoginButton
      onClick={handleAppleLoginClick}
      className={compact ? styles.compactButton : undefined}
    >
      {!compact && (
        <span className={styles.label}>{t('auth.connectWithApple', 'Continuer avec Apple')}</span>
      )}
    </AppleLoginButton>
  );
};

export default AppleSignInButton;
